export default __webpack_public_path__ + "static/SRF 3355ACS50 - Product Specifications & Technical Data-b8d66556c3b4c8a8f24ca7b940856fde.pdf";